import { useNavigate } from 'react-router-dom';
import AppVariables from '../../Variables.json';
import PodcastReadDto from '../../dtos/PodcastReadDto';
import SocialMediaPopup from '../social-media/SocialMediaPopup';

interface IProps {
	podcast: PodcastReadDto;
}

function MainPodcast({ podcast }: IProps) {
	const navigate = useNavigate();

	return (
		<div
			className="shadow-lg generic-podcast generic-podcast--main"
			style={{
				backgroundImage: `linear-gradient(
									180deg,
									#00235c00 0%,
									#00235ca3 50%,
									#00235c 100%
      			), url(${podcast.imgUrl})`,
			}}
			onClick={() => {
				navigate({
					pathname: `${AppVariables.REACT_ROUTER_URL}/detalle-podcast`,
					search: `?titulo=${podcast.title}`,
				});
			}}
		>
			<div className="generic-podcast__duration">
				<p className="generic-podcast__duration--time">▶ {podcast.duration}</p>
			</div>
			<div className="generic-podcast__content">
				<div className="generic-podcast__title cursor-pointer">
					<p className="generic-podcast__title-content">{podcast.title}</p>
				</div>
				<div className="generic-podcast__autor">
					<h5 className="inline generic-podcast__autor--name lg:block">{podcast.author}</h5>
					<SocialMediaPopup
						position={window.screen.width < 1024 ? 'left center' : 'right center'}
						url={`${window.location.protocol}//${
							window.location.host
						}/detalle-podcast?titulo=${
							podcast.title ? podcast.title.replaceAll(' ', '%20') : ''
						}`}
					/>
				</div>
			</div>
		</div>
	);
}

export default MainPodcast;
